import React from "react";
import "./ResultTab.scss";
import { useGameState } from "../../../../../hooks/useGameState";
import { highScorePosition } from "../../../../../utils/highScores";
import { Button } from "../../../../../components/Button/Button";
import { Trans, useTranslation } from "react-i18next";
import lottie from "../../../../../assets/lottie/virus2.json";
import { Player } from "@lottiefiles/react-lottie-player";

interface IProps {

}

export function ResultTab(props: IProps) {
    const { t } = useTranslation();
    const { gameState, playerId, points, resetGame } = useGameState();
    const hasWon = gameState === 'win';
    const position = highScorePosition(playerId);
    const positionEnd = 'e';

    return (
        <div className="result-tab-wrapper">
            <div className="result-tab-background">
                <Player
                    autoplay
                    loop
                    src={lottie}
                    style={{ width: '100%', height: '100%'}}
                ></Player>
            </div>
            <div className="result-tab-content">
                <h1>{hasWon ? t('game.you-won') : t('game.out-of-time')}</h1>
                <div className="summary">
                    <Trans i18nKey={"game.points-summary"} values={{ points }} />
                </div>
                {points > 0 ? (
                    <div className="position-text">
                        {/* eslint-disable-next-line react/jsx-no-comment-textnodes */}
                        <p>/////////// {t('game.your-position')} ///////////</p>
                        <p>{ position }<sup>{positionEnd}</sup></p>
                    </div>) : <></>}
            </div>
            <div className="result-tab-footer">
                <div className="side">
                    <Button variant={"hollow"} onClick={() => resetGame('init')}>{t('game.button-return-to-start')}</Button>
                </div>
                <div className="side">
                    <Button variant={"major-alpha"} icon={"arrow-right"} onClick={() => resetGame('play-again')}>{t('game.button-play-again')}</Button>
                </div>
            </div>
        </div>
    )
}
